import { ObjectId } from "bson";

/**
 * Derives a flow step's creation time from its id. Step ids are minted as Mongo
 * ObjectIds (see `dropElement`), whose embedded timestamp records when the step
 * was created. Returns undefined for ids that aren't ObjectIds, so callers fall
 * back to rendering nothing rather than a wrong date.
 */
export function getStepCreatedAt(stepId: string): Date | undefined {
  return ObjectId.isValid(stepId)
    ? new ObjectId(stepId).getTimestamp()
    : undefined;
}
